import { Menus } from "./contracts/menu";
import { USERROLES, FBI_PERMISSIONS } from "../app.config";

export const FnbIMenuResponse: Menus = {

    'leftTopNavigation': [
        {
            'name': 'LEFT_NAV.FNB_HOME_NAV_LABEL_NAME',
            'link': '/food-and-beverage-intelligence',
            'labelMobile': 'LEFT_NAV.FNB_HOME_NAV_LABEL_MOBILE',
            'label': 'LEFT_NAV.FNB_HOME_NAV_LABEL',
            'hover': 'LEFT_NAV.FNB_HOME_NAV_LABEL',
            'breadcrumb': 'Home',
            'text': 'LEFT_NAV.FNB_HOME_NAV_LABEL',
            'icon': 'menu-fbi-landing-view-icon',
            'isSelected': false,
            'subNavigation': [],
            'role': [FBI_PERMISSIONS.FBISiteUser, FBI_PERMISSIONS.FBIDashboard]
        },
        {
            'name': 'LEFT_NAV.TOP_PRIORITIES_NAV_LABEL_NAME',
            'link': '/food-and-beverage-intelligence/priorities',
            'labelMobile': 'LEFT_NAV.TOP_PRIORITIES_NAV_LABEL_MOBILE',
            'label': 'LEFT_NAV.TOP_PRIORITIES_NAV_LABEL',
            'hover': 'LEFT_NAV.TOP_PRIORITIES_NAV_LABEL',
            'breadcrumb': 'Priorities',
            'text': 'LEFT_NAV.TOP_PRIORITIES_NAV_LABEL',
            'icon': 'menu-top-priorities-view-icon',
            'isSelected': false,
            'subNavigation': [],
            'role': [FBI_PERMISSIONS.FBISiteUser, FBI_PERMISSIONS.FBIDashboard]
        },
        {
            'name': 'LEFT_NAV.INSIGHTS_OPPORTUNITIES_NAV_LABEL_NAME',
            'link': '/food-and-beverage-intelligence/opportunities',
            'labelMobile': 'LEFT_NAV.INSIGHTS_OPPORTUNITIES_NAV_LABEL_MOBILE',
            'label': 'LEFT_NAV.INSIGHTS_OPPORTUNITIES_NAV_LABEL',
            'hover': 'LEFT_NAV.INSIGHTS_OPPORTUNITIES_NAV_LABEL',
            'breadcrumb': 'Insights & Opportunities',
            'text': 'LEFT_NAV.INSIGHTS_OPPORTUNITIES_NAV_LABEL',
            'icon': 'menu-fbi-insights-icon',
            'isSelected': false,
            'subNavigation': [],
            'role': [FBI_PERMISSIONS.FBISiteUser, FBI_PERMISSIONS.FBIDashboard]
        }

    ],
    'leftMidNavigation': [
        {
            'name': 'LEFT_NAV.USER_PREFERENCE_NAV_LABEL_NAME',
            'link': '/food-and-beverage-intelligence/user-preferences',
            'labelMobile': 'LEFT_NAV.USER_PREFERENCE_NAV_LABEL_MOBILE',
            'label': 'LEFT_NAV.USER_PREFERENCE_NAV_LABEL',
            'hover': 'LEFT_NAV.USER_PREFERENCE_NAV_LABEL',
            'breadcrumb': '',
            'icon': 'menu-settings-icon',
            'isSelected': false,
            'text': 'LEFT_NAV.USER_PREFERENCE_NAV_LABEL',
            'subNavigation': [],
            'role': [FBI_PERMISSIONS.FBISiteUser, FBI_PERMISSIONS.FBIDashboard]
        }
    ],
    'leftBottomNavigation': [
        {
            'name': 'Training',
            'link': '',
            'labelMobile': 'LEFT_NAV.MAIN_NAV_TRAINING',
            'label': 'LEFT_NAV.MAIN_NAV_TRAINING',
            'hover': '',
            'breadcrumb': 'Training',
            'text': 'LEFT_NAV.MAIN_NAV_TRAINING',
            'icon': 'menu-training-icon',
            'isSelected': false,
            'subNavigation': [
                {
                    'name': 'Training Customers',
                    'link': 'Training-Customers-External',
                    'labelMobile': 'LEFT_NAV.CUSTOMERS',
                    'label': 'LEFT_NAV.CUSTOMERS',
                    'hover': '',
                    'breadcrumb': 'Training Customers',
                    'icon': '',
                    'isSelected': false,
                    'subNavigation': [],
                    'role': [USERROLES.ENVISION4WEB]
                },
                {
                    'name': 'Training Ecolab Associate',
                    'link': 'Training-Ecolab-Associate',
                    'labelMobile': 'LEFT_NAV.ECOLAB_ASSOCIATE',
                    'label': 'LEFT_NAV.ECOLAB_ASSOCIATE',
                    'hover': ' Ecolab Associate ',
                    'breadcrumb': 'Ecolab Associate ',
                    'icon': '',
                    'isSelected': false,
                    'subNavigation': [],
                    'role': [USERROLES.ENVISION4WEB]
                }
            ]
        },
        // Feedback forums sub navigation links are sorted in ascending order.
        {
            'name': 'Feedback - Uservoice',
            'link': '',
            'labelMobile': 'LEFT_NAV.MAIN_NAV_FEEDBACKFORUMS',
            'label': 'LEFT_NAV.MAIN_NAV_FEEDBACKFORUMS',
            'hover': '',
            'breadcrumb': 'Feedback - Uservoice',
            'text': 'LEFT_NAV.MAIN_NAV_FEEDBACKFORUMS',
            'icon': 'menu-feedback-icon',
            'isSelected': false,
            'subNavigation': [
                {
                    'name': 'Actions & Recommendations',
                    'link': 'Action-Recommendation-Uservoice',
                    'labelMobile': 'LEFT_NAV.SUBNAV_ACTION.NAV_LABEL_MOBILE',
                    'label': 'LEFT_NAV.SUBNAV_ACTION.NAV_LABEL',
                    'hover': ' Actions & Recommendations',
                    'breadcrumb': 'Actions & Recommendations',
                    'icon': '',
                    'isSelected': false,
                    'subNavigation': [],
                    'role': [USERROLES.ENVISION4WEB]
                },
                {
                    'name': 'Asset Harvester',
                    'link': 'Asset-Harvester-Uservoice',
                    'labelMobile': 'LEFT_NAV.SUBNAV_SITE_SETUP.NAV_LABEL_MOBILE',
                    'label': 'LEFT_NAV.SUBNAV_SITE_SETUP.NAV_LABEL',
                    'hover': ' Asset Harvester ',
                    'breadcrumb': 'Asset Harvester',
                    'icon': '',
                    'isSelected': false,
                    'subNavigation': [],
                    'role': [USERROLES.ASSETHARVESTERREAD, USERROLES.ASSETHARVESTERREADWRITE]
                },
                {
                    'name': 'Data Visualization',
                    'link': 'data-Visualization-Uservoice',
                    'labelMobile': 'LEFT_NAV.SUBNAV_DATA_VISUALIZATION.NAV_LABEL_MOBILE',
                    'label': 'LEFT_NAV.SUBNAV_DATA_VISUALIZATION.NAV_LABEL',
                    'hover': 'Data Visualization',
                    'breadcrumb': 'Data Visualization',
                    'icon': 'icon-icon_admin',
                    'isSelected': false,
                    'subNavigation': [],
                    'role': [USERROLES.VISDASHBOARD]
                },
                {
                    'name': 'E-Data',
                    'link': 'E-Data-Uservoice',
                    'labelMobile': 'LEFT_NAV.SUBNAV_E_DATA.NAV_LABEL_MOBILE',
                    'label': 'LEFT_NAV.SUBNAV_E_DATA.NAV_LABEL',
                    'hover': 'E-Data',
                    'breadcrumb': 'E-Data',
                    'icon': '',
                    'isSelected': false,
                    'subNavigation': [],
                    'role': [USERROLES.ENVISION4WEB]
                },
                  {
                    'name': 'ECHO (Ecolab Communication Hub Operator)',
                    'link': 'ECHO-Uservoice',
                    'labelMobile': 'LEFT_NAV.SUBNAV_ECHO.NAV_LABEL_MOBILE',
                    'label': 'LEFT_NAV.SUBNAV_ECHO.NAV_LABEL',
                    'hover': 'ECHO (Ecolab Communication Hub Operator)',
                    'breadcrumb': 'ECHO (Ecolab Communication Hub Operator)',
                    'icon': '',
                    'isSelected': false,
                    'subNavigation': [],
                    'role': [USERROLES.ENVISION4WEB]
                },
                {
                    'name': 'Financial Impact',
                    'link': 'financial-impact-Uservoice',
                    'labelMobile': 'LEFT_NAV.SUBNAV_FINANCIAL_IMPACT.NAV_LABEL_MOBILE',
                    'label': 'LEFT_NAV.SUBNAV_FINANCIAL_IMPACT.NAV_LABEL',
                    'hover': 'Financial Impact',
                    'breadcrumb': 'Financial Impact',
                    'icon': 'icon-icon_admin',
                    'isSelected': false,
                    'subNavigation': [],
                    'role': [USERROLES.FIDASHBOARD, USERROLES.FIADMIN]
                },
                {
                    'name': 'Inventory Management',
                    'link': 'Inventory-Management-Uservoice',
                    'labelMobile': 'LEFT_NAV.SUBNAV_INVENTORY_MANAGEMENT.NAV_LABEL_MOBILE',
                    'label': 'LEFT_NAV.SUBNAV_INVENTORY_MANAGEMENT.NAV_LABEL',
                    'hover': 'Inventory Management',
                    'breadcrumb': 'Inventory Management',
                    'icon': '',
                    'isSelected': false,
                    'subNavigation': [],
                    'role': [USERROLES.ENVISION4WEB]
                },
                {
                    'name': 'My Documents',
                    'link': 'my-documents-Uservoice',
                    'labelMobile': 'LEFT_NAV.MAIN_NAV_MYDOCUMENTS_MOBILE',
                    'label': 'LEFT_NAV.MAIN_NAV_MYDOCUMENTS',
                    'hover': 'LEFT_NAV.MAIN_NAV_MYDOCUMENTS',
                    'breadcrumb': 'My Documents',
                    'text': 'LEFT_NAV.MAIN_NAV_MYDOCUMENTS',
                    'icon': 'ico-nav-my-documents',
                    'isSelected': false,
                    'subNavigation': [],
                    'role': [USERROLES.ENVISION4WEB]
                },
                {
                    'name': 'Omni',
                    'link': 'Omni-Uservoice',
                    'labelMobile': 'LEFT_NAV.SUBNAV_OMNI.NAV_LABEL_MOBILE',
                    'label': 'LEFT_NAV.SUBNAV_OMNI.NAV_LABEL',
                    'hover': ' Omni ',
                    'breadcrumb': 'Omni',
                    'icon': '',
                    'isSelected': false,
                    'subNavigation': [],
                    'role': [USERROLES.OMNIDASHBOARD]
                },
                {
                    'name': 'Service Summary Dashboard',
                    'link': 'service-summary-Uservoice',
                    'labelMobile': 'LEFT_NAV.SUBNAV_SSD.NAV_LABEL_MOBILE',
                    'label': 'LEFT_NAV.SUBNAV_SSD.NAV_LABEL',
                    'hover': ' Service Summary Dashboard',
                    'breadcrumb': 'Service Summary Dashboard',
                    'icon': '',
                    'isSelected': false,
                    'subNavigation': [],
                    'role': [USERROLES.ENVISION4WEB]
                },
                {
                    'name': 'Ecolab® Water Track IQ™',
                    'link': 'water-track-iq-Uservoice',
                    'labelMobile': '<span>Ecolab<sup>&reg </sup> Water Track IQ™</span>',
                    'label': '<span>Ecolab<sup>&reg </sup> Water Track IQ™</span>',
                    'hover': 'Ecolab® Water Track IQ™',
                    'breadcrumb': 'Ecolab® Water Track IQ™',
                    'icon': 'icon-icon_admin',
                    'subNavigation': [],
                    'isSelected': false,
                    'role': [USERROLES.WFIDASHBOARD]
                },
                {
                    'name': 'Water Quality',
                    'link': 'Water-Quality-Uservoice',
                    'labelMobile': '<span>Ecolab<sup>&reg</sup> Water Quality IQ™ </span>',
                    'label': '<span>Ecolab<sup>&reg</sup> Water Quality IQ™ </span>',
                    'hover': ' Ecolab® Water Quality IQ™',
                    'breadcrumb': 'Ecolab® Water Quality IQ™',
                    'icon': '',
                    'isSelected': false,
                    'subNavigation': [],
                    'role': [USERROLES.WQDASHBOARD, USERROLES.WQADMIN]
                },
                {
                    'name': 'Ecolab® Water Safety IQ™',
                    'link': 'Ecolab-Water-Safety-IQ-Uservoice',
                    'labelMobile': '<span>Ecolab<sup>&reg</sup> Water Safety IQ™</span>',
                    'label': '<span>Ecolab<sup>&reg</sup> Water Safety IQ™</span>',
                    'hover': 'Ecolab® Water Safety IQ™',
                    'breadcrumb': 'Ecolab® Water Safety IQ™',
                    'icon': '',
                    'isSelected': false,
                    'subNavigation': [],
                    'role': [USERROLES.WSIDASHBOARD, USERROLES.WSIADMIN]
                }
            ]
        },
        {
            'name': 'Support Info',
            'link': '',
            'labelMobile': 'LEFT_NAV.MAIN_NAV_SUPPORT_SAFETY_INFO',
            'label': 'LEFT_NAV.MAIN_NAV_SUPPORT_SAFETY_INFO',
            'hover': '',
            'breadcrumb': 'Support Info',
            'text': 'LEFT_NAV.MAIN_NAV_SUPPORT_INFO',
            'icon': 'menu-support-icon',
            'isSelected': false,
            'isVisible': true,
            'subNavigation': [
                {
                    'name': 'Ecolab Digital Support:(866) 851 – 8670',
                    'link': '',
                    'href': 'tel:(866) 851 – 8670',
                    'labelMobile': 'LEFT_NAV.ECOLAB_DIGITAL_SUPPORT',
                    'label': 'LEFT_NAV.ECOLAB_DIGITAL_SUPPORT',
                    'hover': '',
                    'breadcrumb': 'Ecolab Digital Support:(866) 851 – 8670',
                    'icon': '',
                    'isSelected': false,
                    'isVisible': true,
                    'isInternalUser': false,
                    'region': ['North America', 'Latinamerica'],
                    'subNavigation': [],
                    'role': [USERROLES.ENVISION4WEB]
                },
                {
                    'name': 'Onboarding Support:\n 855-432-6522',
                    'link': '',
                    'href': 'tel:855-432-6522',
                    'labelMobile': 'LEFT_NAV.ONBOARDING_SUPPORT_NA',
                    'label': 'LEFT_NAV.ONBOARDING_SUPPORT_NA',
                    'hover': '',
                    'breadcrumb': 'Onboarding Support:\n 855-432-6522',
                    'icon': '',
                    'isSelected': false,
                    'isVisible': true,
                    'isInternalUser': true,
                    'region': ['North America'],
                    'subNavigation': [],
                    'role': [USERROLES.ENVISION4WEB]
                },
                {
                    'name': 'Onboarding Support:\n +31 71 524 1111',
                    'link': '',
                    'href': 'tel:+31 71 524 1111',
                    'labelMobile': 'LEFT_NAV.ONBOARDING_SUPPORT_EU',
                    'label': 'LEFT_NAV.ONBOARDING_SUPPORT_EU',
                    'hover': '',
                    'breadcrumb': 'Onboarding Support:\n +31 71 524 1111',
                    'icon': '',
                    'isSelected': false,
                    'isVisible': true,
                    'isInternalUser': true,
                    'region': ['Europe'],
                    'subNavigation': [],
                    'role': [USERROLES.ENVISION4WEB]
                },
                {
                    'name': 'Onboarding Support:\n Digital Contacts',
                    'link': '',
                    'href': '',
                    'labelMobile': 'LEFT_NAV.ONBOARDING_SUPPORT_IMEA_PACIFIC',
                    'label': 'LEFT_NAV.ONBOARDING_SUPPORT_IMEA_PACIFIC',
                    'hover': '',
                    'breadcrumb': 'Onboarding Support: Digital Contacts',
                    'icon': '',
                    'isSelected': false,
                    'isVisible': true,
                    'isInternalUser': true,
                    'region': ['Pacific', 'Greater China', 'Latinamerica', 'Mid.East/Africa', 'Unknown'],
                    'subNavigation': [],
                    'role': [USERROLES.ENVISION4WEB]
                },
                {
                    'name': 'Ecolab Digital Support:',
                    'link': '',
                    'href': '',
                    'labelMobile': 'LEFT_NAV.ECOLAB_DIGITAL_SUPPORT_ALL',
                    'label': 'LEFT_NAV.ECOLAB_DIGITAL_SUPPORT_ALL',
                    'hover': '',
                    'breadcrumb': 'Ecolab Digital Support:',
                    'icon': '',
                    'isSelected': false,
                    'isVisible': true,
                    'isInternalUser': false,
                    'region': ['Europe', 'Pacific', 'Mid.East/Africa'],
                    'subNavigation': [],
                    'role': [USERROLES.ENVISION4WEB]
                },
                //Should uncomment it after getting confirmed menu
                // {
                //   'name': 'Onboarding Support: ',
                //   'link': '',
                //   'href': 'tel:',
                //   'labelMobile': 'LEFT_NAV.ONBOARDING_SUPPORT_IMEA',
                //   'label': 'LEFT_NAV.ONBOARDING_SUPPORT_IMEA',
                //   'hover': '',
                //   'breadcrumb': 'Onboarding Support:',
                //   'icon': '',
                //   'isSelected': false,
                //   'isVisible': true,
                //   'isInternalUser': true,
                //   'region': ['Greater China', 'Latinamerica', 'Mid.East/Africa'],
                //   'subNavigation': [],
                //   'role': ['8f516db4-ddd2-4bed-969a-5de2d9ab12ee']
                // },
                {
                    'name': 'Email',
                    'link': '',
                    'href': '',
                    'target': '',
                    'labelMobile': 'LEFT_NAV.EGIC_EMAIL',
                    'label': 'LEFT_NAV.EGIC_EMAIL',
                    'hover': 'Email',
                    'breadcrumb': 'Email',
                    'icon': '',
                    'isSelected': false,
                    'isVisible': true,
                    'isInternalUser': true,
                    'region': ['North America', 'Europe', 'Greater China', 'Pacific', 'Latinamerica', 'Mid.East/Africa', 'Unknown'],
                    'subNavigation': [],
                    'role': [USERROLES.ENVISION4WEB]
                },
                {
                    'name': 'Site Action Request',
                    'link': 'SITE Creation (Emily Synal) (formsite.com)',
                    'href': '',
                    'labelMobile': 'LEFT_NAV.SITE_ACTION_REQUEST',
                    'label': 'LEFT_NAV.SITE_ACTION_REQUEST',
                    'hover': 'Site Action Request',
                    'breadcrumb': 'Site Action Request',
                    'icon': '',
                    'isSelected': false,
                    'isVisible': true,
                    'isInternalUser': true,
                    'region': ['North America', 'Europe', 'Greater China', 'Pacific', 'Latinamerica', 'Mid.East/Africa', 'Unknown'],
                    'subNavigation': [],
                    'role': [USERROLES.ENVISION4WEB]
                },
                {
                    'name': 'Digital Support Dashboard',
                    'link': '',
                    'href': 'https://ecolab.sharepoint.com/sites/IndustrialDigitalSupportDashboard/SitePages/ECOLAB3D-noticeboard.aspx?csf=1&&web=1&&e=ZuTHyf&&cid=6ed84063-33a2-4490-8729-b4d391a134ed',
                    'labelMobile': 'LEFT_NAV.DIGITAL_SUPPORT_DASHBOARD',
                    'label': 'LEFT_NAV.DIGITAL_SUPPORT_DASHBOARD',
                    'hover': 'Digital Support Dashboard',
                    'breadcrumb': 'Digital Support Dashboard',
                    'icon': '',
                    'isSelected': false,
                    'isVisible': true,
                    'isInternalUser': true,
                    'region': ['North America', 'Europe', 'Greater China', 'Pacific', 'Latinamerica', 'Mid.East/Africa'],
                    'subNavigation': [],
                    'role': [USERROLES.ENVISION4WEB]
                },
                {
                    'name': 'Emergency Numbers',
                    'link': 'common-pages/emergency-numbers',
                    'labelMobile': 'LEFT_NAV.EMERGENCY',
                    'label': 'LEFT_NAV.EMERGENCY',
                    'hover': '',
                    'breadcrumb': 'Emergency Numbers',
                    'icon': '',
                    'isSelected': false,
                    'subNavigation': [],
                    'role': [USERROLES.ENVISION4WEB]
                },
                {
                    'name': 'SH&E Reference',
                    'link': 'common-pages/safety-health',
                    'labelMobile': 'LEFT_NAV.SH&E',
                    'label': 'LEFT_NAV.SH&E',
                    'hover': 'SH&E Reference',
                    'breadcrumb': 'SH&E Reference',
                    'icon': '',
                    'isSelected': false,
                    'subNavigation': [],
                    'role': [USERROLES.ENVISION4WEB]
                },
                {
                    'name': 'Access Request',
                    'link': 'common-pages/access-request',
                    'labelMobile': 'LEFT_NAV.ECOLAB3D_ACCESS_REQUEST_FOR_USERS',
                    'label': 'LEFT_NAV.ECOLAB3D_ACCESS_REQUEST_FOR_USERS',
                    'hover': 'Access Request',
                    'breadcrumb': 'Access Request',
                    'icon': '',
                    'isInternalUser': true,
                    'isSelected': false,
                    'subNavigation': [],
                    'role': [USERROLES.ENVISIONSALES]
                }
            ]
        }
    ]
};